import { Component } from '@angular/core';
import { UserDetailsComponent } from "../user-details/user-details.component";
import { UserPhotosComponent } from "../user-photos/user-photos.component";
import { UserFriendsComponent } from "../user-friends/user-friends.component";
import { QuickSearchComponent } from "../quick-search/quick-search.component";
import { PostsComponent } from "../posts/posts.component";
import { UploadPostComponent } from "../upload-post/upload-post.component";
import { ApiServicesService } from '../services/api-services.service';
import { UserDetailsService } from '../services/user-details.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-profile-tab',
  standalone: true,
  imports: [UserDetailsComponent, UserPhotosComponent, UserFriendsComponent, QuickSearchComponent, PostsComponent, UploadPostComponent,CommonModule],
  templateUrl: './profile-tab.component.html',
  styleUrl: './profile-tab.component.css'
})

export class ProfileTabComponent {
  is_myProfile=false;
  userData: any;
  isActivity=false;
  constructor(private apiservices: ApiServicesService, private userdetails: UserDetailsService){}
  ngOnInit(){
    this.userdetails.userdetails$.subscribe((userData) => {
      this.userData = userData;
      if (userData && userData.user) {
        this.is_myProfile = this.apiservices.checkProfile(this.userData.user.username);
      }
    });
  }

}
